<template>
  <div class="progress-step-bar">
    <div
      v-for="(step, index) in steps"
      :key="`step-${index}`"
      class="progress-step-bar__item"
      :class="{
        'progress-step-bar__item--noninteractive': step.noninteractive || false,
        'progress-step-bar__item--clickable': step.isClickable || false,
        'progress-step-bar__item--current': index === currentStep,
        'progress-step-bar__item--completed': index < currentStep,
      }"
    >
      <button
        class="progress-step-bar__item-counter"
        :class="{
          'progress-step-bar__item-counter--noninteractive':
            step.noninteractive || false,
          'progress-step-bar__item-counter--current': index === currentStep,
          'progress-step-bar__item-counter--completed': index < currentStep,
        }"
        :title="step.label"
        @click="toggleStep(index)"
      >
        <span v-if="hasCounter">
          {{ step.counterLabel || index + 1 }}
        </span>
      </button>
      <div
        v-if="hasLabels && step.label"
        class="progress-step-bar__item-name"
        :class="{
          'progress-step-bar__item-name--noninteractive':
            step.noninteractive || false,
          'progress-step-bar__item-name--current': index === currentStep,
          'progress-step-bar__item-name--completed': index < currentStep,
        }"
      >
        {{ step.label }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CompanyProfileStatusBar',
    props: {
      steps: {
        type: Array,
        required: true,
      },
      currentStep: {
        type: Number,
        default: 0,
      },
      hasCounter: Boolean,
      hasLabels: Boolean,
      isClickable: Boolean,
    },
    methods: {
      toggleStep(index) {
        if (this.steps[index].noninteractive || !this.isClickable) return;
        this.$emit('clicked-step', index);
      },
    },
  };
</script>

<style lang="scss" scoped>
  $bar-height: 4px;
  $dot-size: 12px;
  $dot-half: calc($dot-size / 2);
  $center-position: calc($dot-half - ($bar-height / 2));

  .progress-step-bar {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: $dot-half;
    width: 100%;

    &__item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;

      font-size: 12px;

      @include screen-md {
        font-size: 16px;
      }

      &--noninteractive {
        cursor: default;
      }

      &:first-child::before {
        content: none;
      }
      &:last-child::after {
        content: none;
      }

      &::before {
        position: absolute;
        content: '';
        border-bottom: $bar-height solid var(--itr-grey-dark);
        width: 100%;
        top: $center-position;
        left: -50%;
        z-index: 2;
      }

      &::after {
        position: absolute;
        content: '';
        border-bottom: $bar-height solid var(--itr-grey-dark);
        width: 100%;
        top: $center-position;
        left: 50%;
        z-index: 2;
      }

      &--completed {
        &::after {
          position: absolute;
          content: '';
          border-bottom: $bar-height solid var(--itr-green-mid);
          width: 100%;
          top: $center-position;
          left: 50%;
          z-index: 3;
          transition: left 200ms ease-in-out;
        }
      }
    }

    &__item-counter {
      position: relative;
      z-index: 5;
      display: flex;
      justify-content: center;
      align-items: center;
      width: $dot-size;
      height: $dot-size;
      border-radius: 50%;
      background: var(--itr-green-mid);
      margin-bottom: $center-position;
      transform: scale(1);
      transition: transform 200ms ease-in-out;

      &--current {
        // transform: scale(1.3);
      }

      &--completed,
      &--current {
        background-color: var(--itr-green);
      }

      &--noninteractive {
        cursor: default;
        transform: scale(1);
        &:hover {
          transform: scale(1);
        }
      }

      &--clickable {
        cursor: pointer;
        transform: scale(1);
        &:hover {
          // transform: scale(1.3);
          // transition: transform 200ms ease-in-out;
        }
      }
    }

    &__item-name {
      position: relative;
      z-index: 5;
      font-weight: 400;
      color: var(--itr-grey-dark);
      margin-top: $dot-half;
      text-align: center;
      width: 100%;
      transition: font-weight 200ms ease-in-out;

      &--current {
        font-weight: 700;
      }
    }
  }
</style>
